import { ROUTES } from '@app/AppRoutes/routes';
import { TPathOptions } from '../App/types/types';

// show this module in dev/QA ENV only
const mode = import.meta.env.MODE;

const show =
	['qa', 'staging'].includes(mode) &&
	localStorage.getItem('campaigns') === 'true';

const campaignsPathOptions: TPathOptions = {
	apiKey: show ? 'zeal-merchant-analytics' : 'campaigns',
	path: ROUTES.CAMPAIGNS.path,
	label: 'campaigns',
	iconName: 'bullhorn',
	menuOrder: 1,
	ownApp: false,
	excludedFor: [],
	subMenu: [
		{
			label: 'campaigns_overview',
			path: ROUTES.CAMPAIGNS.path,
		},
	],
};

export default campaignsPathOptions;
